import {
  AutoTabs,
  BetaSecondaryNav,
  BetaSecondaryNavList,
} from "@zapier/design-system";
import { useAssetLinks } from "./useAssetLinks";
import { TRASH_HREF } from "./trashHref";
import { useEmitTrashNavClickEvent } from "../../../events/useEmitTrashNavClickEvent";

import styles from "./AssetLinks.module.css";

export function AssetLinks() {
  const { desktopLinks, mobileLinks, selectedHref } = useAssetLinks();
  const { emit: emitTrashNavClick } = useEmitTrashNavClickEvent();

  return (
    <>
      <div className={styles.mobileNav}>
        <AutoTabs
          items={mobileLinks}
          selectedItemHref={selectedHref}
          size="medium"
          type="brand"
          aria-label="Asset navigation"
          onChooseItem={(item) => {
            if (item.href === TRASH_HREF) {
              emitTrashNavClick("mobile-tabs");
            }
          }}
        />
      </div>
      <div className={styles.desktopNav}>
        <BetaSecondaryNav
          selectedItem={selectedHref}
          aria-label="Asset navigation"
        >
          <BetaSecondaryNavList>{desktopLinks}</BetaSecondaryNavList>
        </BetaSecondaryNav>
      </div>
    </>
  );
}
